module.exports = __webpack_public_path__ + "media/images/b_4-0736bcef89024ac1ed7917ff593b9be9.png";